// src/pages/_app.js
import { Figtree, Playfair_Display } from 'next/font/google';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/css/bootstrap-utilities.min.css';
import '../styles/colors.css';
import '../styles/globals.css';
import '../styles/globalsupdated.css';
import '../styles/header.css';
import '../styles/footer.css';
import 'aos/dist/aos.css';
import "../styles/contact.css";
import "../styles/event.css";
import '../styles/community.css';
import "../styles/tab.css";
import "../styles/floating.css";

const figtree = Figtree({ subsets: ['latin'], display: 'swap', variable: '--font-figtree' });
const playfair = Playfair_Display({ subsets: ['latin'], display: 'swap', variable: '--font-playfair' });

import { useEffect, useState } from 'react';
import AOS from 'aos';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import store, { persistor } from '../store/store';
import Layout from './layout';
import LoginPopup from '../componets/loginpopup'; // added
// ...existing code...

export default function App({ Component, pageProps }) {
  const [showLoginPopup, setShowLoginPopup] = useState(false); // added

  useEffect(() => {
    AOS.init({ duration: 1000 });
    if ('serviceWorker' in navigator) {
      navigator.serviceWorker.register('/firebase-messaging-sw.js').catch(console.error);
    }
  }, []);

  // open popup when URL hash is #login and on hash changes
  useEffect(() => {
    if (typeof window === 'undefined') return;

    const checkHash = () => {
      setShowLoginPopup(window.location.hash === '#login');
    };

    // check on initial load
    checkHash();

    const onHashChange = () => checkHash();
    window.addEventListener('hashchange', onHashChange);

    return () => window.removeEventListener('hashchange', onHashChange);
  }, []);

  const handleCloseLogin = () => {
    setShowLoginPopup(false);
    if (typeof window !== 'undefined') {
      const url = window.location.pathname + window.location.search;
      history.replaceState(null, '', url);
    }
  };

  return (
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <main className={`${figtree.variable} ${playfair.variable}`}>
          <Layout>
            <Component {...pageProps} />
          </Layout>

          {showLoginPopup && <LoginPopup onClose={handleCloseLogin} />}
        </main>
      </PersistGate>
    </Provider>
  );
}
